import React from "react"
import { Link } from "gatsby"

export default () => (
    <header className="header">
    <div className="container">
      <div className="site">
        <Link to={`/`}>
          <div className="blogname">Tyler Blog</div>
        </Link>
      </div>
      <nav className="nav">
        <ul>
          <li><Link to={`/about/`}>About</Link></li>
          <li><Link to={`/blog/`}>Blog</Link></li>
          {/* <li><Link to={`/catlist/`}>Category</Link></li> */}
          <li><Link to={`https://4sf023busxd.typeform.com/to/VEPcEgua`} target="_blank">Contact</Link></li>
        </ul>
      </nav>
    </div>
  </header>

)